import { isUnrecognizedServerActionError } from '@/helpers/is-unrecognized-server-action-error'

const RELOAD_GUARD_KEY = 'zamply:server-action-stale-reload'
const RELOAD_GUARD_TTL_MS = 30_000

/**
 * Recarrega a página uma vez para buscar os IDs novos das Server Actions após
 * deploy. O guard evita loop se o reload falhar de novo em seguida.
 */
export function recoverStaleServerAction(error: unknown): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  if (!isUnrecognizedServerActionError(error)) {
    return false
  }

  try {
    const raw = sessionStorage.getItem(RELOAD_GUARD_KEY)
    const lastReloadAt = raw ? Number.parseInt(raw, 10) : Number.NaN
    if (
      Number.isFinite(lastReloadAt) &&
      Date.now() - lastReloadAt < RELOAD_GUARD_TTL_MS
    ) {
      return false
    }

    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()))
  } catch {
    // sessionStorage pode falhar em modo privado — segue com o reload
  }

  window.location.reload()
  return true
}
